import React from 'react';

import { useGridContext } from './context/GridContext';
import { GridRowContext } from './context/GridRowContext';
import { GridCells } from './GridCells';
import { GridCellsPhantom } from './GridCellsPhantom';

import cn from './Grid.module.scss';

export const GridRows = () => {
  const {
    visible_rows,
    start_index,
    is_scrolling,
    total_columns_width,
    row_height,
    width,
    theme,
    velocity,
  } = useGridContext();

  if (!visible_rows.length) {
    return (
      <div
        className={cn.row}
        style={{
          position: 'sticky',
          bottom: '0px',
          width,
          height: `${row_height}px`,
          background: theme.cell.background,
        }}
      >
        <p className={cn.empty}>No Records</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      {visible_rows.map((row, index) => (
        <div
          key={`row-${start_index}-${index}`}
          className={cn.row}
          style={{
            top: `${(start_index + index) * row_height}px`,
            height: `${row_height}px`,
            width: `${total_columns_width}px`,
            opacity: is_scrolling ? 0.6 : 1,
          }}
        >
          <GridRowContext.Provider value={{ row, index }}>
            <GridCells key={`row-cells-${start_index}-${index}`} index={index} theme={theme.cell} />
          </GridRowContext.Provider>
        </div>
      ))}
      {is_scrolling &&
        Array.from({ length: velocity }).map((_, index) => (
          <div
            key={`phantom-row-${index}`}
            className={cn.row}
            style={{
              position: 'sticky',
              top: `${index * row_height}px`,
              height: `${row_height}px`,
              width: `${total_columns_width}px`,
              opacity: 0.8,
            }}
          >
            <GridCellsPhantom index={index} theme={theme.cell} />
          </div>
        ))}
    </React.Fragment>
  );
};
